import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencySpacing',
  pure: true
})
export class CurrencySpacingPipe implements PipeTransform {
  transform(value: any): any {
    if (value === null || value === undefined) return value;
    const text = String(value);
    return text
      .replace(/\u00A0/g, ' ')
      .replace(/₨(?=\s*\d)/g, 'Rs.')
      .replace(/\bPKR(?=\s*\d)/g, 'Rs.')
      .replace(/(^|[\s(])Rs\.?(?=\d)/gi, '$1Rs. ');
  }
}
